module.exports = __webpack_public_path__ + "img/kumarakom.56b249eb.png";